import React from 'react';
import Reveal from './Reveal';

const ContactSection: React.FC = () => {
    return (
        <section className="py-20 bg-white border-t border-slate-100" id="contato">
            <div className="container mx-auto px-4">

                <div className="bg-brand-darkGreen rounded-3xl overflow-hidden shadow-2xl relative">

                    {/* OTIMIZAÇÃO: Substituição de Blur por Gradient */}
                    <div className="absolute top-0 right-0 w-96 h-96 bg-[radial-gradient(circle,rgba(0,104,55,0.4)_0%,rgba(0,0,0,0)_70%)] -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
                    <div className="absolute bottom-0 left-0 w-64 h-64 bg-[radial-gradient(circle,rgba(254,193,14,0.2)_0%,rgba(0,0,0,0)_70%)] translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

                    <div className="grid grid-cols-1 lg:grid-cols-2">

                        <div className="p-8 md:p-16 relative z-10 flex flex-col justify-center">
                            <Reveal>
                                <div className="inline-block px-3 py-1 bg-brand-yellow text-brand-darkGreen font-bold text-xs rounded-full mb-6 uppercase tracking-wider">
                                    <span>Faça parte da rede</span>
                                </div>
                                <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
                                    Fortaleça o seu <br />
                                    <span className="text-brand-yellow">
                                        Conselho Tutelar
                                    </span>
                                </h2>
                                <div className="text-brand-green/30 text-lg mb-8 text-white/80 leading-relaxed">
                                    <p>A ACONTURS Litoral oferece suporte jurídico, formações exclusivas e uma rede de troca de experiências vital para o exercício da função.</p>
                                </div>

                                <div className="space-y-4 mb-8">
                                    <div className="flex items-center gap-4 text-white/90">
                                        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-brand-yellow">
                                            <i className="fas fa-check"></i>
                                        </div>
                                        <span>Defesa das prerrogativas do Conselheiro</span>
                                    </div>
                                    <div className="flex items-center gap-4 text-white/90">
                                        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-brand-yellow">
                                            <i className="fas fa-check"></i>
                                        </div>
                                        <span>Cursos e Certificações Válidas</span>
                                    </div>
                                </div>

                                <a
                                    href="https://wa.me/5551982755065"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="inline-flex items-center justify-center gap-3 bg-white text-brand-darkGreen px-8 py-4 rounded-full font-bold text-lg hover:bg-brand-yellow transition-colors shadow-lg w-full md:w-auto"
                                >
                                    <i className="fab fa-whatsapp text-2xl"></i>
                                    QUERO ME FILIAR
                                </a>
                            </Reveal>
                        </div>

                        <div className="bg-brand-green/20 p-8 md:p-16 flex flex-col justify-center relative backdrop-blur-sm border-l border-white/5">
                            <Reveal delay={200}>
                                <h3 className="text-2xl font-bold text-white mb-8">
                                    Canais de Atendimento
                                </h3>

                                <ul className="space-y-6">
                                    <li className="flex items-start gap-4 group cursor-pointer">
                                        <div className="w-12 h-12 rounded-xl bg-brand-darkGreen flex items-center justify-center text-brand-yellow group-hover:scale-110 transition-transform">
                                            <i className="fas fa-envelope"></i>
                                        </div>
                                        <div>
                                            <span className="block text-brand-yellow text-xs font-bold uppercase tracking-wider">
                                                E-mail Oficial
                                            </span>
                                            <a href="mailto:contato@aconturslitoral.com.br" className="text-white text-lg hover:underline">contato@aconturslitoral.com.br</a>
                                        </div>
                                    </li>

                                    <li className="flex items-start gap-4 group cursor-pointer">
                                        <div className="w-12 h-12 rounded-xl bg-brand-darkGreen flex items-center justify-center text-brand-yellow group-hover:scale-110 transition-transform">
                                            <i className="fab fa-instagram"></i>
                                        </div>
                                        <div>
                                            <span className="block text-brand-yellow text-xs font-bold uppercase tracking-wider">
                                                Siga no Instagram
                                            </span>
                                            <a href="https://instagram.com/rs.aconturs" target="_blank" rel="noreferrer" className="text-white text-lg hover:underline">@rs.aconturs</a>
                                        </div>
                                    </li>

                                    <li className="flex items-start gap-4 group">
                                        <div className="w-12 h-12 rounded-xl bg-brand-darkGreen flex items-center justify-center text-brand-yellow">
                                            <i className="fas fa-map-pin"></i>
                                        </div>
                                        <div>
                                            <span className="block text-brand-yellow text-xs font-bold uppercase tracking-wider">
                                                Sede Regional
                                            </span>
                                            <div className="text-white text-lg">
                                                Tramandaí / RS
                                            </div>
                                            <div className="text-white/60 text-sm">
                                                Atendimento itinerante nos municípios
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </Reveal>
                        </div>

                    </div>
                </div>

            </div>
        </section>
    );
};

export default ContactSection;